<template>
    <div class="slider-container">
        <slot name="header"></slot>
        <div class="slider-gabarit">
            <transition>
                <div
                    :key="idx"
                    class="slide"
                >
                    <div
                        class="image-holder"
                    >
                        <Parallax
                            class="image-parallax"
                            :effect="'translateY'"
                            :power="0.125"
                        >

                            <div
                                class="image-content"
                            >
                                <div
                                    class="image-box"
                                    :style="{
                                        backgroundImage: `url(${currentSlide.image.url})`
                                    }"
                                >
                                    <img
                                        :src="currentSlide.image.url"
                                        :alt="currentSlide.image.alt"
                                        :title="currentSlide.image.title"
                                        class="seo-image"
                                    />
                                </div>
                                <div
                                    class="image-overlay"
                                />
                            </div>
                        </Parallax>
                    </div>
                </div>
            </transition>
        </div>
        <slot/>
    </div>
</template>

<script>
import Parallax from '@/components/animation/Parallax'
export default {
    components: {
        Parallax
    },
    props: {
        followup: {
            type: Boolean,
            default: false
        },
        slider: {
            type: Object,
            default() {}
        },
        idx: {
            type: Number,
            default: 0
        }
    },
    computed: {
        currentSlide() {
            return this.slider.slides[this.idx]
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.slider-container
    position: relative
    display: flex
    &.original
        align-items: flex-end
    .drilldown &
        @media print
            display: none
    @include media-breakpoint-down($lg)
        flex-direction: column
        display: block
.slider-gabarit
    position: relative
    height: 0
    padding-bottom: 44.6354166667%
    overflow: hidden
    flex: 1
    @include media-breakpoint-down($lg)
        padding-bottom: 66.6667%
    @include media-breakpoint-down($md)
        padding-bottom: 100%
    .original &
        .drilldown &
            display: none
            @include media-breakpoint-down($lg)
                display: block
    .backup &
        @include media-breakpoint-down($lg)
            display: none
        .drilldown &
            padding-bottom: 106%
            // overflow: visible
            margin-bottom: -6%
            margin-left: -16%
        .reverse &
            margin-left: 0%
            margin-right: -16%

.slide
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    overflow: hidden
    will-change: transform
    &.v-enter-active
        transition: transform .825s cubic-bezier(.65,0,.25,1)
        .image-holder
            transition: transform .825s cubic-bezier(.65,0,.25,1)
    &.v-leave-active
        transition: transform .825s cubic-bezier(.65,0,.25,1)
        .image-holder
            transition: transform .825s cubic-bezier(.65,0,.25,1)
    &.v-enter
        transform: translateY(100%)
        .image-holder
            transform: translateY(-62.5%)
    &.v-leave-to
        transform: translateY(-31.25%)
.image-overlay
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    background-color: rgba(0,0,0,.2)
.image-holder
    width: 100%
    height: 100%
    position: absolute
.image-parallax
    width: 100%
    height: 100%
.image-box
    width: 100%
    height: 100%
    background-position: 50% 50%
    background-size: cover
    background-repeat: no-repeat
    will-change: transform
    transition: transform .825s cubic-bezier(.65,0,.25,1)
.image-content
    width: 100%
    height: 100%
    position: absolute
    transform: scale(1.125)

</style>
